module.exports = __webpack_public_path__ + "static/media/CS-CLUB.7e38bd10.jpg";